"use client";

import State from "@/components/state";
import { ExclamationTriangleIcon } from "@radix-ui/react-icons";

export default function GlobalError({
  error,
  reset,
}: {
  error: Error & { digest?: string };
  reset: () => void;
}) {
  return (
    <html>
      <body>
        <div className="h-screen">
          <State
            icon={ExclamationTriangleIcon}
            title="Oops!"
            description="Qualcosa è andato storto durante il caricamento"
            action={{
              text: "Torna indietro",
              onClick: () => {
                window.history.back();
              },
            }}
          />
        </div>
      </body>
    </html>
  );
}
